<div class="w-full h-[80vh] relative">

    <!-- Loading State -->
    <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white z-10">
      <p class="text-gray-500 text-sm font-semibold animate-pulse">Loading preview...</p>
    </div>

    <!-- PDF -->
    <iframe
      *ngIf="isPdf"
      [src]="displayUrl"
      class="w-full h-[80vh]"
      (load)="onIframeLoad()">
    </iframe>

    <div *ngIf="isOfficeDoc && editorConfig" class="w-full h-[80vh]">
      <document-editor
        id="office-doc-preview"
        [documentServerUrl]="onlyOfficeServerUrl"
        [config]="editorConfig"
        [events_onDocumentReady]="onDocumentReady"
        [onLoadComponentError]="onEditorError">
      </document-editor>
    </div>

  </div>
